import React from 'react';
import {Input, Select, Form, Modal, DatePicker,Upload,message,Button,Icon,Col,Row,Drawer,Descriptions,Badge,Statistic} from 'antd';
import moment from 'moment';

const PurOrderDetail =(props)=>{
	
	const {onCancel,visible,item} =props
	
	let width = window.innerWidth <768 ? window.innerWidth*0.8 :window.innerWidth*0.35
	return (
	
	<Drawer   title={item.contract_id?<span>合同号:{item.contract_id}</span>:<span>无合同订单</span>}     placement="right"      closable={false}      onClose={onCancel}    visible={visible}  width={width}  >

		<Descriptions title="收款人信息" layout="vertical" bordered>
			<Row><Col span={24}><pre style={{ margin: 0, textAlign: 'left' }}>
                 {JSON.stringify(item.payee_list,null , 2)}<br/><br/><br/>
                  </pre></Col>
			</Row>

		</Descriptions>
	  	<Descriptions title="商品信息" layout="vertical" bordered>		
		<Row><Col span={24}><pre style={{ margin: 0, textAlign: 'left' }}>
                 {JSON.stringify(item.product_info_list,null , 2)}<br/><br/><br/>
                  </pre></Col>				 
                 </Row>
		
	  </Descriptions>

	   
      </Drawer>
	
	)

}


export default PurOrderDetail;
